// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"2752adcc","982":"700e5ea8"}[chunkId] + ".chunk.css";
};